export const ACCOUNT_RESEARCH = {
  id: 'demo-skl-account-research',
  title: 'Account research brief',
  description:
    'A one-page brief on any company: what they do, how they make money, recent news, likely priorities, and who to talk to.',
  apps: ['Web research', 'HubSpot'],
  usedCount: 14,
  lastUsedMinutesAgo: 2 * 24 * 60 + 190,
  instructions: `**When asked to research a company:**

1. Find the company's site, latest funding, headcount trend, and the last 90 days of news.
2. Explain the business model in two sentences — who pays, for what, and how often.
3. Check HubSpot for an existing account, open deals, and past conversations. Quote the last touchpoint.
4. List three likely priorities for this year, each tied to a source.
5. Name two or three people to approach, with role and why they matter.

**Format:** one page. Lead with a three-line summary. Cite every claim with a link. Say "unknown" rather than guess.`,
  examples: [
    'Research brief on Snowflake ahead of Thursday’s call',
    'What should I know about Rippling before we pitch them?',
  ],
}
